module.exports = __webpack_public_path__ + "img/146.f4870d9c.jpg";